class NgConfig {
    static UPLOAD_URL = '/api/uploads/start/'
    static FINISH_URL = '/api/uploads/finish/'
    static JOB_START_URL = '/api/jobs/start/'
    static JOB_STATUS_URL = '/api/jobs/status/'
    static FILES_URL = '/myfiles/'
    static PARAMS_URL = '/tools/params'
    static FILES_API_URL = '/api/files/'
    static MAX_UPLOAD_FILE_SIZE = 1024 * 1024 * 1024
}

export default NgConfig